/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum OrderStatus {
    OPEN = 'open',
    EXPIRED = 'expired',
    ERROR = 'error',
    CANCELLED = 'cancelled',
    FILLED = 'filled',
    UNVERIFIED = 'unverified',
    INSUFFICIENT_FUNDS = 'insufficient-funds',
}
